module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.limited_list), function(task) {
    return _c('compose', {
      key: task.guid,
      attrs: {
        "task": task,
        "template": task.template_or_new(),
        "id": task.guid,
        "number_composes": _vm.list.length,
        "event": _vm.event
      },
      on: {
        "compose-close": function($event) {
          return _vm.removeFromList(task)
        },
        "compose-hide": _vm.hideCompose
      }
    })
  }), (_vm.hidden_list_has_elements) ? _c('div', {
    staticClass: "open-compose",
    on: {
      "click": function($event) {
        _vm.show_menu = !_vm.show_menu
      }
    }
  }, [_vm._v(_vm._s('+ ' + _vm.hidden_list.length))]) : _vm._e(), (_vm.show_menu && _vm.hidden_list_has_elements) ? _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onClickaway),
      expression: "onClickaway"
    }],
    staticClass: "compose-menu"
  }, _vm._l((_vm.hidden_list), function(task, index) {
    return _c('div', {
      staticClass: "hidden-compose",
      attrs: {
        "title": _vm.compose_header(task, index)
      },
      on: {
        "click": function($event) {
          return _vm.incrementList(task)
        }
      }
    }, [_vm._v(_vm._s(_vm.compose_header(task, index)))])
  }), 0) : _vm._e(), _c('quota-exceeded')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-195cef09!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/compose/list.vue
// module id = 1029
// module chunks = 1